import React from "react";
import {Timeslot} from "types/entities/Timeslot";
import {CheckCircleIcon} from "@heroicons/react/24/solid";
import {getAvailableKartingDuration} from "utils/packageUtils";
import {useTranslation} from "react-i18next";
import Dates from "utils/Dates";
import {useTypedSelector} from "helpers/reducers";
import {eventCategories} from "helpers/config";

interface BookingSellerSelectedPackageNoticeProps {
    selectedTimeslot: Timeslot | null;
}

const BookingSellerSelectedPackageNotice = (props: BookingSellerSelectedPackageNoticeProps) => {
    const {t} = useTranslation();
    const selectedPackageCategory = useTypedSelector(state => state.bookingState.bookingProcess.filter.category);

    const showEventHoursCategory = !selectedPackageCategory ? false : eventCategories.includes(selectedPackageCategory);

    if (!props?.selectedTimeslot || (props?.selectedTimeslot && getAvailableKartingDuration(props.selectedTimeslot) == 100)) {
        return <></>;
    }

    const isAfterSixEvening = parseInt(Dates.dayjs(props.selectedTimeslot.start_at).format("H")) >= 18;

    return (
        <div className={"BookingSellerSelectedPackageNotice w-full items-center justify-center mb-2 flex"}>
            <div className={"flex flex-col items-center lg:px-1 lg:py-1 xl:px-4 xl:py-3 border shadow rounded-md bg-white"}>
                <h3 className={"font-bold"}>{t("Available slots")}</h3>
                {getAvailableKartingDuration(props.selectedTimeslot) == -100 && (
                    <div className={"flex items-center justify-center gap-x-1"}>
                        <span>{t("Only ticket without karting")}</span>
                        <CheckCircleIcon className={"text-arbo-yellow size-4"} />
                    </div>
                )}
                {getAvailableKartingDuration(props.selectedTimeslot) == 0 && (
                    <>
                        {(!props.selectedTimeslot.karting_available ||
                            !props.selectedTimeslot.karting_available_4h ||
                            !props.selectedTimeslot.karting_available_6h) && (
                            <div className={"flex items-center justify-center gap-x-1"}>
                                <span>{t("Ticket without karting")}</span>
                                <CheckCircleIcon className={"text-arbo-yellow size-4"} />
                            </div>
                        )}
                        {Object.keys(props.selectedTimeslot.karting_available_array).map((duration, index) => {
                            if (!props?.selectedTimeslot?.karting_available_array[duration]) {
                                return null;
                            }
                            // if (props.showEventHoursCategory) {
                            if (showEventHoursCategory) {
                                if (duration !== "3.0" && duration !== "4.5" && duration !== "6.0") {
                                    return null;
                                }
                            } else {
                                if (isAfterSixEvening) {
                                    if (!["1.0", "2.0", "4.0", "6.0"].includes(duration)) {
                                        return null;
                                    }
                                } else if (!["2.0", "4.0", "6.0"].includes(duration)) {
                                    return null;
                                }
                            }
                            return (
                                <div key={index} className={"flex items-center justify-center gap-x-1"}>
                                    <span>{t("hour_ticket_with_karting", {hour: duration.toString().replace(".0", "")})}</span>
                                    <CheckCircleIcon className={"text-arbo-red size-4"} />
                                </div>
                            );
                        })}
                    </>
                )}
            </div>
        </div>
    );
};

export default BookingSellerSelectedPackageNotice;